<template>
  <div style="padding-left: 20px">
    <p><h3>{{ $t('Unauthorized.title') }}</h3></p>
    <p>{{ $t('Unauthorized.body') }}</p>
  </div>
</template>
<script>
export default {
  name: 'Unauthorized'
}
</script>